import { createReducer, createActions } from 'reduxsauce';
import { normalize } from 'normalizr';
import { contactSchema } from './schemas';
import { fetchContacts } from '../api/contacts';
import applicationLoadingActions from './applicationLoading';

const { Types, Creators } = createActions({
    getContacts : (licenca, search = '')=>{
        return dispatch=>{
            fetchContacts({ 
                licenca,
                busca: search
             }).then((resp)=>{
                dispatch({
                    type : Types.GET_CONTACTS_SUCCESS,
                    payload : resp.data.data || []
                });
                dispatch(applicationLoadingActions.loadApplicationSuccess());
            });
        }
    },
    setContactsFilter: ['payload'],
    getContactsSuccess : null,
    selectContact : ['idContato'],
    contactSelected : ['payload']
  }, {})


export const contatoTypes = Types;
export default Creators;

const INITIAL_STATE = {
    entities : {
        contacts : null,
        conversations : null,
        contact : null,
        contactsFilter: ''
    }
}

/** Helpers functions */

const getContatctsEntity = ({entities})=>{
    return entities.contacts && Object.values(entities.contacts).map((contact)=>contact)
}


/*  Reducers */
const getContactsSuccess = (state, action) => {
    const {entities} =normalize(action.payload, contactSchema);
    return {
        entities: {
            ...state.entities,
            ...entities,
            contacts: {
                ...state.entities.contacts,
                ...entities.contacts
            }
        }
    };
}

const setContactsFilter = (state, action) => {
    return {
        ['entities']: {
            ...state['entities'],
            contactsFilter: action.payload
        },
    }
}

const selectContact = (state, action)=>{
    return {
        ['entities'] : {
            ...state['entities'], 
            contact : action.payload,
            contactsFilter: ''
        }
    }
};

/** Selectors */
export const getContacts = (state)=>{
    const contacts = state.contatos;
    if(!contacts) return [];
    const contactsEntity = getContatctsEntity(contacts);
    if(contactsEntity){
        return contactsEntity.filter(contact => contact.st_nome_pes.toLowerCase().includes(contacts.entities.contactsFilter.toLowerCase()));
    }
    return contactsEntity;
}

export const getCurrentContact = (state)=>{
    const { entities:{ contact } } = state.contatos;
    return contact;
}

export const getContactsFilter = state => state.contatos.entities.contactsFilter;

export const reducer = createReducer(INITIAL_STATE,{
    [Types.GET_CONTACTS_SUCCESS] : getContactsSuccess,
    [Types.CONTACT_SELECTED] : selectContact,
    [Types.SET_CONTACTS_FILTER]: setContactsFilter
});


// WEBPACK FOOTER //
// ./src/redux/contatoStore.js